import { render, staticRenderFns } from "./TaskCreateWorkItemDialog.vue?vue&type=template&id=568cc014&scoped=true"
import script from "./TaskCreateWorkItemDialog.vue?vue&type=script&lang=js"
export * from "./TaskCreateWorkItemDialog.vue?vue&type=script&lang=js"
import style0 from "./TaskCreateWorkItemDialog.vue?vue&type=style&index=0&id=568cc014&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568cc014",
  null
  
)

export default component.exports